module.exports = __webpack_public_path__ + "img/product-insurance-1.6a96a0c5.png";